// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

.inventory-form .form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/Inventory/Inventory.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AACF;AAAE;EACE,kCAAA;AAEJ;AAAE;EACE,gBAAA;EACA,eAAA;AAEJ;;AAEA;EACE;IAAO,uBAAA;EAEP;EADA;IAAK,yBAAA;EAIL;AACF;AAFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAIF;AAHE;EAAI,gBAAA;EAAkB,eAAA;AAOxB;;AAHE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAMJ","sourcesContent":[".loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n  .spin {\n    animation: spin 1s linear infinite;\n  }\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n  p { margin-top: 16px; font-size: 16px; }\n}\n\n.inventory-form {\n  .form-control {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
